export default function updateAction(state, payload) {
  return {
    ...state,
    zaposlenik: {
      ...state.zaposlenik,
      ...payload,
    },
  };
}
